import styled from 'styled-components';
import star from '~/assets/icons/star_exp.svg';
import openCaseLines from '../../assets/images/open_case_lines.svg';
import openCaseDots from '../../assets/images/open_case_dots.svg';
import openCaseMask from '../../assets/images/open_case_mask.svg';
import openCaseLight from '../../assets/images/open_case_light.png';
import shadow from '../../assets/images/open_case_reward_shadow.png';
import lightColor from '../../assets/images/open_case_reward_light_color.png';
import circle from '../../assets/images/open_case_reward_circle.png';
import buttonLight from '../../assets/images/open_case_reward_button.png';
import { TextLabel } from '../TextLabel';

const StyledWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.97);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 2;
	transform: translate(-50%, -50%);
	width: 2400px;
	height: 2400px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledLightColor = styled.div<{ $color: string }>`
	position: absolute;
	top: -850px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 3;
	width: 100%;
	height: calc(100% + 850px);
	background-color: ${(props) => props.$color};
	mask-image: url(${lightColor});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 3320px 2600px;
	-webkit-mask-image: url(${lightColor});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 3320px 2600px;
`;

const StyledCircle = styled.div<{ $color: string }>`
	position: absolute;
	top: -900px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 3;
	width: 1800px;
	height: 1800px;
	background-color: ${(props) => props.$color};
	mask-image: url(${circle});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 1800px 1800px;
	-webkit-mask-image: url(${circle});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 1800px 1800px;
`;

const StyledDecBg = styled.div`
	position: absolute;
	top: 0;
	left: 50%;
	z-index: 4;
	transform: translateX(-50%);
	width: 100%;
	height: 340px;

	background: url(${openCaseDots}), url(${openCaseLines});
	background-repeat: repeat, no-repeat;
	background-size:
		auto,
		2000px 2000px;
	background-position:
		0 0,
		center -660px;

	mask-image: url(${openCaseMask});
	mask-size: 1920px 340px;
	mask-repeat: no-repeat;
	mask-position: 0 0;
`;

const StyledRewardContainer = styled.div`
	position: relative;
	z-index: 5;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 80px;
`;

const StyledRewardTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 14px;

	${TextLabel} {
		color: #ffffff;
	}
`;

const StyledXPContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 40px;
	margin-top: 9px;
	padding: 0 10px;
	gap: 10px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	${TextLabel} {
		font-weight: 700;
		font-size: 20px;
		line-height: 23px;
		color: #ffffff;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledStar = styled.div`
	width: 20px;
	height: 20px;
	mask-image: url(${star});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${star});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffb500;
`;

const StyledRewardImg = styled.img`
	width: auto;
	height: 316px;
	user-select: none;
	pointer-events: none;
`;

const StyledRewardTakeButtonLight = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 3;
	width: 413px;
	height: 200px;
	background-color: #2d70da;
	mask-image: url(${buttonLight});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 413px 200px;
	-webkit-mask-image: url(${buttonLight});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 413px 200px;
	opacity: 0.5;
	transition:
		background-color 0.3s ease,
		opacity 0.3s ease;
`;

const StyledRewardTakeButton = styled.div`
	position: relative;
	z-index: 4;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	width: 213px;
	height: 50px;
	background-color: #2d70da;
	border-radius: 10px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${TextLabel} {
		font-weight: 400;
		font-size: 18px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		${TextLabel} {
			color: #000000;
		}

		& + ${StyledRewardTakeButtonLight} {
			opacity: 0.25;
			background-color: #ffffff;
		}
	}
`;

const StyledRewardTakeButtonContainer = styled.div`
	position: relative;
`;

const StyledLight = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 3;
	width: 1728px;
	height: 865px;
	background-image: url(${openCaseLight});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export {
	StyledWrapper,
	StyledShadow,
	StyledLightColor,
	StyledDecBg,
	StyledRewardContainer,
	StyledRewardTextContainer,
	StyledRewardImg,
	StyledRewardTakeButton,
	StyledRewardTakeButtonContainer,
	StyledRewardTakeButtonLight,
	StyledCircle,
	StyledXPContainer,
	StyledStar,
	StyledLight,
};
